import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { DateTime } from "luxon";
import { NgForm } from "@angular/forms";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatDialog } from "@angular/material/dialog";
import { MonitorExtratoDialogComponent } from "./monitor-extrato-dialog.component";
import { ReceivablesService } from "../../services/receivables.service";
import { ReceivableFund } from "../../model/domain/ReceivableFund";
import { ReceivableStatus } from "../../model/domain/ReceivableStatus";
import { ReceivableMonitor } from "../../model/domain/ReceivableMonitor";
import { Bank } from "../../model/domain/Bank";

export interface History {
  date: string;
  status: string;
}

@Component({
  selector: "app-monitor-recebiveis",
  templateUrl: "./monitor-recebiveis.component.html",
  styleUrls: ["./monitor-recebiveis.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ display: "none" })),
      state("expanded", style({ display: "table-row" })),
      transition("expanded <=> collapsed", animate("10ms ease")),
    ]),
  ],
})
export class MonitorRecebiveisComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public receivablesService: ReceivablesService
  ) {}

  funds: ReceivableFund[] = null;
  statuses: ReceivableStatus[] = null;
  receivableMonitor: ReceivableMonitor[] = null;

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  Hoje: Date = new Date();
  StartDate: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  EndDate: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  CodeStatus: string = null;
  FileName = "";
  FundDocument: string = null;
  BankCode: string = null;
  expandedElement: any;
  Banks: Bank[] = null;

  displayedColumns: string[] = [
    "fundName",
    "paymentDate",
    "processingDate",
    "tedValue",
    "toBankAccount",
    "sequenceNumber",
    "status",
  ];
  displayedDetailColumns: string[] = ["date", "status"];

  dataSource: any = null;

  defaultPage = 1;
  currentPage = 1;
  defaultSize = 10;
  totalPages: number = null;
  totalItems: number = null;
  listedPages = [];
  firstItemOnPage: number;
  lastItemOnPage: number;

  serverTime: string = null;

  isExpansionDetailRow = (i: number, row: Object) =>
    row.hasOwnProperty("detailRow");

  ngOnInit() {
    this.receivablesService.GetServerTimestamp().subscribe((q) => {
      this.serverTime = q;
    });
    this.receivablesService.GetStatuses().subscribe((s) => {
      this.statuses = s;
    });
    this.receivablesService.GetFunds().subscribe((f) => {
      this.funds = f;
    });

    this.getBanks();

    this.clear();
    this.populate();
  }

  clear() {
    this.frm.reset();
    this.StartDate = DateTime.local().toJSDate();
    this.EndDate = DateTime.local().toJSDate();
    this.CodeStatus = null;
    this.FileName = "";
    this.FundDocument = null;
    this.BankCode = null;
  }

  populate(
    page: number = this.defaultPage,
    pageSize: number = this.defaultSize
  ) {
    const params: any[] = [
      this.StartDate,
      this.EndDate,
      this.CodeStatus,
      this.FileName,
      this.FundDocument,
      this.BankCode,
      page,
      pageSize,
    ];

    this.receivablesService.GetReceivableMonitors(...params).subscribe((s) => {
      const rows = [];
      s.results.forEach((element) => {
        rows.push(element, {
          detailRow: true,
          id: element.id,
          history: element.statusDetail,
        });
      });

      this.dataSource = rows;
      this.totalPages = s.pageCount;
      this.totalItems = s.rowCount;
      this.firstItemOnPage = s.firstRowOnPage;
      this.lastItemOnPage = s.lastRowOnPage;
      this.currentPage = s.currentPage;
      this.listedPages = [];

      let startPage = this.currentPage - 2;
      if (startPage <= 0) {
        startPage = 1;
      }

      let maxPage = this.currentPage + 2;
      while (maxPage > this.totalPages) {
        maxPage--;
      }

      for (let i = startPage; i <= maxPage; i++) {
        this.listedPages.push(i);
      }
    });
  }

  periodoError() {
    if (this.StartDate == null || this.StartDate == null) {
      return true;
    }
    const dateDiff =
      (this.EndDate.getTime() - this.EndDate.getTime()) / 86400000;

    return dateDiff > 30 || dateDiff < 0;
  }

  openDialog(bankName: string): void {
    const dialogRef = this.dialog.open(MonitorExtratoDialogComponent, {
      width: "800px",
      data: { bankName: bankName },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  isTimezoneLoaded() {
    return this.serverTime != null;
  }

  janelaMenorHorario(horaJanela: number) {
    const horarioServer = parseInt(this.serverTime.toString().substr(8, 2), 10);

    return horarioServer >= horaJanela;
  }

  fundoExiste() {
    return this.FundDocument == null ? false : this.FundDocument.length >= 3;
  }

  getBanks() {
    this.receivablesService.GetBanks().subscribe((s) => {
      this.Banks = s;
    });
  }
}
